import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import Disclosure from 'modules/payroll_bundle/components/Disclosure'

import { IncidenceToShow, StatItem, calculateWidth } from './IncidenceStats'

const INCIDENCES_TO_SHOW: IncidenceToShow[] = [
  {
    id: 1,
    name: 'hiring',
    pending: 12,
    sent: 10,
    showTooltip: false,
  },
  {
    id: 2,
    name: 'contract',
    pending: 5,
    sent: 2,
    showTooltip: false,
  },
  {
    id: 3,
    name: 'termination',
    pending: 2,
    sent: 2,
    showTooltip: false,
  },
  {
    id: 4,
    name: 'sick',
    pending: 8,
    sent: 7,
    showTooltip: false,
  },
  {
    id: 5,
    name: 'others',
    pending: 2,
    sent: 12,
    showTooltip: false,
  },
]

const BAR_COLOR = 'grey600'
const PROGRESS_COLOR = 'grey200'

const EmptyState = () => {
  const { navigation } = useNavigation()

  const highestTotal = Math.max(
    ...INCIDENCES_TO_SHOW.map((incidence) => (incidence.sent ?? 0) + (incidence.pending ?? 0))
  )

  return (
    <Box gap="s8" style={{ flex: '1' }}>
      <Box flexDirection="row" height="s32" alignItems="center" paddingX="s8">
        <Text.Normal weight="medium" size="300">
          {i18n.t('payroll_bundle.payroll_dashboard.incidences_summary.heading')}
        </Text.Normal>
        <Disclosure
          tooltipText={i18n.t(
            'payroll_bundle.payroll_dashboard.incidences_summary.heading_tooltip.tooltip'
          )}
        />
      </Box>
      <Box
        width="full"
        height="s200"
        flexDirection="row"
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs008' }}
        minHeight="s200"
      >
        <Box padding="s24" gap="s16" justifyContent="spaceAround" minWidth="s200" width="full">
          <Box gap="s12">
            <Icon.Large icon="document-folder-files" color="grey600" />

            <Text.Normal size="200" color="grey1000">
              {i18n.t('payroll_bundle.payroll_dashboard.incidences_summary.empty.title')}
            </Text.Normal>
          </Box>

          <Button.Router
            type="secondary"
            to={navigation.payrollBundle.inhouseActivation.fullPath()}
          >
            {i18n.t('payroll_bundle.payroll_dashboard.incidences_summary.empty.button_text')}
          </Button.Router>
        </Box>

        <Box flexDirection="row" paddingRight="s24" paddingY="s12" width="full">
          <Box justifyContent="spaceBetween" width="full" gap="s8" style={{ opacity: '0.5' }}>
            {INCIDENCES_TO_SHOW.map((incidence) => {
              const total = (incidence.sent ?? 0) + (incidence.pending ?? 0)
              const width = calculateWidth(total, highestTotal)

              return (
                <StatItem
                  incidence={incidence}
                  key={incidence.id}
                  progressbarWidth={width}
                  barColor={BAR_COLOR}
                  progressColor={PROGRESS_COLOR}
                />
              )
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmptyState
